import DashboardIcon from "@mui/icons-material/Dashboard";
import WebIcon from "@mui/icons-material/Language";
import HistoryIcon from "@mui/icons-material/History";
import PersonIcon from "@mui/icons-material/Person";
import type { SvgIconComponent } from "@mui/icons-material";

export { DRAWER_WIDTH } from "@/constants/layout";

export interface NavItem {
  path: string;
  icon: SvgIconComponent;
  i18nKey: string;
  requiresAuth: boolean;
  showBadge?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    path: "/dashboard",
    icon: DashboardIcon,
    i18nKey: "nav.dashboard",
    requiresAuth: true,
  },
  {
    path: "/scrapers",
    icon: WebIcon,
    i18nKey: "nav.scrapers",
    requiresAuth: true,
    showBadge: true,
  },
  {
    path: "/logs",
    icon: HistoryIcon,
    i18nKey: "nav.logs",
    requiresAuth: true,
  },
  {
    path: "/account",
    icon: PersonIcon,
    i18nKey: "nav.account",
    requiresAuth: false,
  },
];
